import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';

interface IProps {
  onClose: () => void;
}

export const BrowserCompatibilityWarning = ({ onClose }: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <S_Modal
      isOpen={true}
      toggle={onClose}
      headerText={t('browser_compatibility_warning_header')}
      buttons={
        <Button
          variant='outlined'
          onClick={onClose}
        >
          {t('ok')}
        </Button>
      }
    >
      <p>{t('browser_compatibility_warning_body1')}</p>
      <p dangerouslySetInnerHTML={{ __html: t('browser_compatibility_warning_body2') }} />
    </S_Modal>
  );
};
